export function getEnumDisplay (enumList, value) {
    let foundEnum = enumList.find((e) => e.value === value);

    return foundEnum ? foundEnum.display : 'Unknown';
}

export function getEnumBadgeClass (enumList, value) {
    let foundEnum = enumList.find((e) => e.value === value);

    return foundEnum && foundEnum.badgeClass ? foundEnum.badgeClass : 'badge-light';
}

export function getEnumValueByDisplay (enumList, display) {
    let foundEnum = enumList.find((e) => e.display === display);

    return foundEnum ? foundEnum.value : 0;
}

export function getDropdownByEnumList (enumList) {
    return enumList.filter(e => e.value && e.value !== 0);
}

export const doctorConsultationNoPharmacyPrescriptionStatus = [
    {
        'value': 1,
        'display': 'Awaiting Payment',
        'badgeClass': 'badge-danger'
    },
    {
        'value': 2,
        'display': 'Pending Delivery',
        'badgeClass': 'badge-info'
    },
    {
        'value': 3,
        'display': 'Delivered',
        'badgeClass': 'badge-success'
    },
    {
        'value': 99,
        'display': 'Cancelled',
        'badgeClass': 'badge-secondary'
    }
];

export const appointmentStatus = [
    {
        'value': 0,
        'display': 'Awaiting Doctor Response',
        'badgeClass': 'badge-primary'
    },
    {
        'value': 1,
        'display': 'Doctor Accepted',
        'badgeClass': 'badge-primary'
    },
    {
        'value': 2,
        'display': 'Ended',
        'badgeClass': 'badge-secondary'
    },
    {
        'value': 99,
        'display': 'Cancelled',
        'badgeClass': 'badge-secondary'
    },
    {
        'value': 998,
        'display': 'Awaiting Payment',
        'badgeClass': 'badge-danger'
    },
    {
        'value': 999,
        'display': 'No Payment Received',
        'badgeClass': 'badge-warning'
    },
    {
        'value': 1000,
        'display': 'Paid',
        'badgeClass': 'badge-success'
    }
];

export const doctorDashboardAppointmentStatus = [
    {
        'value': 0,
        'display': 'New Request',
        'badgeClass': 'badge-success'
    },
    {
        'value': 1,
        'display': 'Accepted',
        'badgeClass': 'badge-primary'
    },
    {
        'value': 998,
        'display': 'Awaiting Payment',
        'badgeClass': 'badge-warning'
    },
    {
        'value': 1000,
        'display': 'Start Session',
        'badgeClass': 'badge-info'
    }
];

export const clinicQueueStatus = [
    {
        'value': 0,
        'display': 'Cancelled',
        'badgeClass': 'badge-secondary'
    },
    {
        'value': 1,
        'display': 'Waiting',
        'badgeClass': 'badge-primary'
    },
    {
        'value': 2,
        'display': 'Attending',
        'badgeClass': 'badge-info'
    },
    {
        'value': 3,
        'display': 'Price Review',
        'badgeClass': 'badge-danger'
    },
    {
        'value': 4,
        'display': 'Completed',
        'badgeClass': 'badge-success'
    }
];

export const genericStatus = [{
    'value': 1,
    'display': 'Pending',
    'badgeClass': 'badge-warning'
},
{
    'value': 2,
    'display': 'Approved',
    'badgeClass': 'badge-success'
},
{
    'value': 3,
    'display': 'Rejected',
    'badgeClass': 'badge-danger'
},
{
    'value': 4,
    'display': 'Resend',
    'badgeClass': 'badge-primary'
},
{
    'value': 5,
    'display': 'Partial Approved',
    'badgeClass': 'badge-info'
}];
